import { keccak256 } from './utils/keccak256';

const isTuple = input => {
  return input.type === 'tuple';
};

export const parseType = input => {
  if (isTuple(input)) {
    return `(${input.components.map(parseType)})`;
  }

  return input.type;
};
export const getIdentifier = contractFunction => {
  const types = contractFunction.inputs.map(parseType).join(',');
  return keccak256(`${contractFunction.name}(${types})`).slice(0, 8);
};
//# sourceMappingURL=identifier.js.map